import * as React from 'react';
import CommandStrings from '../../scope/commands/commands.resx';
import { Facet } from '../../../models/Facet';
import { DocumentType } from '../../../operations/createDocument/DocumentType';
import { CreateDocumentAction } from '../../actions/createDocument/CreateDocumentAction';
import { ICommand } from '../../../models/commands/ICommand';
import { getCommandIconProps } from '../getCommandIconProps';
import { HideWithSelection } from '../../selectionVisibility/SelectionVisibility';

export const createWordCommand: ICommand = {
  key: new Facet('createWord').id,
  automationId: 'createWordCommand',
  name: CommandStrings.CreateWord,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.Word } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'docx',
    size: 16
  })
};

export const createExcelCommand: ICommand = {
  key: new Facet('createExcel').id,
  automationId: 'createExcelCommand',
  name: CommandStrings.CreateExcel,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.Excel } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'xlsx',
    size: 16
  })
};

export const createPowerPointCommand: ICommand = {
  key: new Facet('createPowerPoint').id,
  automationId: 'createPowerPointCommand',
  name: CommandStrings.CreatePowerPoint,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.PowerPoint } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'pptx',
    size: 16
  })
};

export const createOneNoteCommand: ICommand = {
  key: new Facet('createOneNote').id,
  automationId: 'createOneNoteCommand',
  name: CommandStrings.CreateOneNote,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.OneNote } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'onetoc',
    size: 16
  })
};

export const createExcelSurveyCommand: ICommand = {
  key: new Facet('createExcelSurvey').id,
  automationId: 'createExcelSurveyCommand',
  name: CommandStrings.CreateExcelSurvey,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.ExcelSurvey } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'xlsx',
    size: 16
  })
};

export const createFormForExcelCommand: ICommand = {
  key: new Facet('createFormForExcel').id,
  automationId: 'createFormForExcelCommand',
  name: CommandStrings.CreateFormForExcel,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.ExcelForm } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'xlsx',
    size: 16
  })
};

export const createVisioCommand: ICommand = {
  key: new Facet('createVisio').id,
  automationId: 'createVisioCommand',
  name: CommandStrings.CreateVisio,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.Visio } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'vsdx',
    size: 16
  })
};

export const createBohemiaCommand: ICommand = {
  key: new Facet('createBohemia').id,
  automationId: 'createBohemiaCommand',
  name: CommandStrings.CreateBohemia,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.Bohemia } /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'b',
    size: 16
  })
};

export const createPragueCommand: ICommand = {
  key: new Facet('createPrague').id,
  automationId: 'createPragueCommand',
  name: CommandStrings.CreatePrague,
  action: <HideWithSelection><CreateDocumentAction documentType={ DocumentType.Prague} /></HideWithSelection>,
  iconProps: getCommandIconProps({
    extension: 'p',
    size: 16
  })
};
